 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users":"calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users","dashboard":"dashboard","logout":"logout","recovery":"recovery","reset":"reset","categories~clients~customers~login~profile~tasks~users":"categories~clients~customers~login~profile~tasks~users","categories":"categories","profile":"profile","clients":"clients","customers":"customers","tasks":"tasks","users":"users","calendar":"calendar","login":"login","report":"report"}[chunkId]||chunkId) + "." + {"404":"ccc0467c","calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users":"aafda28d","dashboard":"726f54e6","logout":"fd812567","recovery":"93b7f819","reset":"daa4b954","chunk-0ec9d43e":"399195ab","chunk-532728fe":"a90640c5","chunk-2d228cf0":"3868ef55","chunk-2f58f8c5":"7bdb5d06","chunk-529f5fa5":"2e04ac13","categories~clients~customers~login~profile~tasks~users":"ada571b9","categories":"ecbec21b","chunk-4444416a":"102a1866","profile":"d21aa237","clients":"4d060b99","customers":"aadc34f5","tasks":"4f98ff84","users":"acf6361f","chunk-1cb34626":"0a8ed59a","calendar":"8f75e1b9","chunk-09e51c0a":"e2ff38cd","chunk-360cfe50":"9acb166d","chunk-50c92aa2":"5e1bd7f3","chunk-75f0404a":"aec0aaf0","chunk-ba9d278c":"9071d75d","login":"b8b15fbc","chunk-1e778941":"9ec0ef66","chunk-3b694b43":"77806be6","chunk-47784588":"7085d35e","chunk-58a6a043":"4d0f0aca","chunk-e34aa36c":"c3656548","report":"4201597c","chunk-69f56dfa":"e758fa1a","chunk-8ff04010":"6972cb30","chunk-efcabe1a":"d4fe158c","chunk-62d9d9d3":"81b8e690","chunk-b91e1c86":"fa144eff","chunk-0bc689a2":"a5af2899","chunk-6e085314":"5620a4c4","chunk-28f629c6":"191f58ba","chunk-1cf65416":"675cf302","chunk-1cf9d52e":"99341352","chunk-6770269a":"e9cf7183","chunk-6dc7c662":"52856f1f","chunk-3e9e736a":"84c49699","chunk-db6f6eb6":"0a5f9f53","chunk-a40949e0":"626278ae","chunk-cae357b2":"98689cd6","chunk-d3a9e35a":"e4b7796d","chunk-360d3578":"34941fe6","chunk-62a4aa4c":"641201c1","chunk-eafa204e":"58ab9213","chunk-16092054":"5b6edbc7","chunk-755b55c7":"2d52c3d7","chunk-2d0b199b":"1937ffad","chunk-3e7f68be":"f03863bf","chunk-2f147b8e":"92dbbaad","chunk-396334ce":"9f986ee0","chunk-ff7e6d0e":"e6655c21","chunk-4c5f825a":"af9d0c53","chunk-2791b0d8":"05e87435","chunk-34b69c5c":"d2371619","chunk-2d21805e":"8aef94f1","chunk-609880c1":"7ed8da9a","chunk-0bf971ad":"0e6ac24d","chunk-6095cbd0":"f04f6f0b","chunk-be96ce1a":"202c5f45","chunk-574bc1f3":"c84ba896"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users":1,"chunk-532728fe":1,"chunk-2f58f8c5":1,"chunk-529f5fa5":1,"categories~clients~customers~login~profile~tasks~users":1,"chunk-4444416a":1,"profile":1,"chunk-1cb34626":1,"calendar":1,"chunk-09e51c0a":1,"chunk-360cfe50":1,"chunk-50c92aa2":1,"chunk-75f0404a":1,"chunk-ba9d278c":1,"login":1,"chunk-1e778941":1,"chunk-3b694b43":1,"chunk-47784588":1,"chunk-58a6a043":1,"chunk-e34aa36c":1,"report":1,"chunk-69f56dfa":1,"chunk-8ff04010":1,"chunk-efcabe1a":1,"chunk-62d9d9d3":1,"chunk-b91e1c86":1,"chunk-6e085314":1,"chunk-28f629c6":1,"chunk-6770269a":1,"chunk-6dc7c662":1,"chunk-3e9e736a":1,"chunk-db6f6eb6":1,"chunk-a40949e0":1,"chunk-cae357b2":1,"chunk-d3a9e35a":1,"chunk-360d3578":1,"chunk-62a4aa4c":1,"chunk-eafa204e":1,"chunk-16092054":1,"chunk-755b55c7":1,"chunk-3e7f68be":1,"chunk-2f147b8e":1,"chunk-396334ce":1,"chunk-ff7e6d0e":1,"chunk-4c5f825a":1,"chunk-2791b0d8":1,"chunk-34b69c5c":1,"chunk-0bf971ad":1,"chunk-574bc1f3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users":"calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users","dashboard":"dashboard","logout":"logout","recovery":"recovery","reset":"reset","categories~clients~customers~login~profile~tasks~users":"categories~clients~customers~login~profile~tasks~users","categories":"categories","profile":"profile","clients":"clients","customers":"customers","tasks":"tasks","users":"users","calendar":"calendar","login":"login","report":"report"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","calendar~categories~clients~customers~dashboard~logout~profile~recovery~reset~tasks~users":"fae4c610","dashboard":"31d6cfe0","logout":"31d6cfe0","recovery":"31d6cfe0","reset":"31d6cfe0","chunk-0ec9d43e":"31d6cfe0","chunk-532728fe":"f2b361d6","chunk-2d228cf0":"31d6cfe0","chunk-2f58f8c5":"ba6fba88","chunk-529f5fa5":"18fd7293","categories~clients~customers~login~profile~tasks~users":"271e4856","categories":"31d6cfe0","chunk-4444416a":"3454c7bc","profile":"dd260574","clients":"31d6cfe0","customers":"31d6cfe0","tasks":"31d6cfe0","users":"31d6cfe0","chunk-1cb34626":"813f34dc","calendar":"8f0680f7","chunk-09e51c0a":"05a399aa","chunk-360cfe50":"3eb55c9f","chunk-50c92aa2":"6cb1c90b","chunk-75f0404a":"2c4d8169","chunk-ba9d278c":"ab1ef08c","login":"e2e96c79","chunk-1e778941":"81afd149","chunk-3b694b43":"41c69ad2","chunk-47784588":"824def88","chunk-58a6a043":"9c1cf683","chunk-e34aa36c":"9482d397","report":"27349476","chunk-69f56dfa":"085c4dc4","chunk-8ff04010":"b5c44049","chunk-efcabe1a":"70613acb","chunk-62d9d9d3":"47093c90","chunk-b91e1c86":"cbea5d08","chunk-0bc689a2":"31d6cfe0","chunk-6e085314":"2052850f","chunk-28f629c6":"822d9ab6","chunk-1cf65416":"31d6cfe0","chunk-1cf9d52e":"31d6cfe0","chunk-6770269a":"8ad0bb85","chunk-6dc7c662":"2052850f","chunk-3e9e736a":"822d9ab6","chunk-db6f6eb6":"822d9ab6","chunk-a40949e0":"2052850f","chunk-cae357b2":"822d9ab6","chunk-d3a9e35a":"2052850f","chunk-360d3578":"885998e6","chunk-62a4aa4c":"2052850f","chunk-eafa204e":"da09e052","chunk-16092054":"2052850f","chunk-755b55c7":"885998e6","chunk-2d0b199b":"31d6cfe0","chunk-3e7f68be":"066df5b5","chunk-2f147b8e":"f78eb1cd","chunk-396334ce":"b284f36f","chunk-ff7e6d0e":"f78eb1cd","chunk-4c5f825a":"f78eb1cd","chunk-2791b0d8":"f78eb1cd","chunk-34b69c5c":"f78eb1cd","chunk-2d21805e":"31d6cfe0","chunk-609880c1":"31d6cfe0","chunk-0bf971ad":"4c5a29c7","chunk-6095cbd0":"31d6cfe0","chunk-be96ce1a":"31d6cfe0","chunk-574bc1f3":"e5d867e8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
